<template>
  <section>
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span>本會創會董事長<br><sup>上</sup>淨<sup>下</sup>空老和尚<br>圓寂四週年追思紀念</span>
        </h3>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-img center :src="`${fourth_anniversary_file_url}/001.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">忍人所不能忍</h4>
        <h4 class="text-center">行人所不能行</h4>
        <b-img center :src="`${fourth_anniversary_file_url}/002.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">靜坐常思己過</h4>
        <h4 class="text-center">若或妄念一起</h4>
        <h4 class="text-center">當下就要教它消滅</h4>
        <b-img center :src="`${fourth_anniversary_file_url}/003.jpg`" fluid></b-img>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4 class="text-center">閒談莫論人非</h4>
        <h4 class="text-center">看一切人皆是菩薩</h4>
        <b-img center :src="`${fourth_anniversary_file_url}/004.jpg`" fluid></b-img>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
2*
Vue.use(BreadcrumbPlugin)
Vue.use(ImagePlugin)

export default {
  name: "fourth-anniversary",
  props: {
    // 
  },
  data() {
    return {
      fourth_anniversary_file_url: 'https://www2.budaedu.org/official-website-data/founder/anniversary-memorial-ceremony/fourth-anniversary'
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  }
}
</script>